var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "reservation-event-modal" } },
    [
      !_vm.isEditing
        ? _c(
            "div",
            { staticClass: "container" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "title", staticStyle: { "font-size": "17px" } },
                [
                  _vm._v(
                    "Randevu Programı : " + _vm._s(_vm.reservationDetail.title)
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.getDate())),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "duration-container" }, [
                _c("span", { staticClass: "material-icons icon" }, [
                  _vm._v("timelapse"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "duration" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.reservationDetail.duration) +
                      " min appointments "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  staticClass: "go-link",
                  on: {
                    click: function ($event) {
                      return _vm.goLink()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons icon" }, [
                    _vm._v("open_in_new"),
                  ]),
                  _vm._v(
                    "\n                Randevu Programı Ayarlara Git\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("a-divider"),
              _vm._v(" "),
              _c("h4", [_vm._v("Rezervasyon Yapan Kişinin Bilgileri")]),
              _vm._v(" "),
              _c("div", { staticClass: "form" }, [
                _c("div", { staticClass: "material-icons icon" }, [
                  _vm._v("format_list_bulleted"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "form-title" }, [
                    _vm._v("Booking form"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "items" },
                    _vm._l(_vm.eventDetail.formValues, function (formInput, i) {
                      return _c("div", { key: i, staticClass: "item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v(_vm._s(formInput.label + ": ")),
                        ]),
                        _vm._v(
                          "\n                            " +
                            _vm._s(formInput.value) +
                            "\n                        "
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "reservation-details" }, [
                _c("h4", [_vm._v("Rezervasyon Detayları")]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-item" }, [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("ticket.ticketFilterList.creationDate")) +
                        ":"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$moment(_vm.eventDetail.createdAt).format("LLLL")
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-item" }, [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("wp.summary")) + ":"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.eventDetail.summary))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-item" }, [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("calendar.description")) + ":"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.eventDetail.description))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-item" }, [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.timePeriod")) + ":"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.eventDetail.timezone))]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.editReservation()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("calendar.cancel")))]
                  ),
                  _vm._v(" "),
                  _vm.isDeletable()
                    ? _c(
                        "div",
                        { staticClass: "delete-button-container" },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: { danger: "" },
                              on: { click: _vm.toggleDeletePopup },
                            },
                            [_vm._v(_vm._s(_vm.$t("message.delete")))]
                          ),
                          _vm._v(" "),
                          _vm.showDeletePopup
                            ? _c("div", { staticClass: "custom-popup" }, [
                                _c("p", [
                                  _vm._v("Silmek istediğinizden emin misiniz?"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "popup-buttons" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "yes-btn",
                                      on: { click: _vm.deleteEvent },
                                    },
                                    [_vm._v("Evet")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "no-btn",
                                      on: { click: _vm.toggleDeletePopup },
                                    },
                                    [_vm._v("Hayır")]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c("ReservationUpdateForm", {
            attrs: { eventDetail: _vm.eventDetail },
            on: {
              updateCompleted: _vm.handleUpdateCompleted,
              cancelUpdate: _vm.handleCancelUpdate,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label-container" }, [
      _c("span", { staticClass: "material-icons icon" }, [
        _vm._v("calendar_month"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "label" }, [_vm._v("Reservation")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }